import { canUseDOM } from 'exenv';
import get from 'lodash/get';
import cachingService from '../../services/caching_service';
import request from '../../utils/request_util';
import Base from '../base_model';
import log from '../../services/logger_service';

export default class InnovationByDesign extends Base {
  static fetch({ year, subpage }, store) {
    const cleanedYear = this.cleanParam(year);

    if (cleanedYear < 2019 && cleanedYear > 2008) {
      const state = store.getState();
      const cacheEnabled = get(state, 'config.cacheEnabled');
      const cacheExpire = get(state, 'config.cacheExpire');
      const cacheNamespace = get(state, 'config.cacheNamespace');
      const host = 'assets.fastcompany.com';
      const options = {};

      const cacheKeyUrl = `https://${host}/multisite_files/fastcompany/ibd/json/categories/idb_${cleanedYear}_categories.json`;
      const cacheKey = `${cacheNamespace}:${cacheKeyUrl}`;

      if (!cacheEnabled) {
        return request.getAsync(cacheKeyUrl, options);
      }

      return cachingService
        .getAsync(cacheKey)
        .then(function fromCache(cacheRes) {
          if (cacheRes) {
            return Promise.resolve(JSON.parse(cacheRes));
          }

          if (!canUseDOM) {
            log.info(`Requesting: ${cacheKeyUrl} from model.`);
          }

          return request
            .getAsync(cacheKeyUrl, options)
            .then(function fetchSuccess(resp) {
              cachingService.setex(cacheKey, cacheExpire, JSON.stringify(resp));
              return resp;
            });
        });
    }

    // START ==============================================
    const state = store.getState();
    const cacheEnabled = get(state, 'config.cacheEnabled');
    const cacheExpire = get(state, 'config.cacheExpire');
    const cacheNamespace = get(state, 'config.cacheNamespace');
    const host = 'fc-api.fastcompany.com';
    const options = {};

    // Handle subpage routing
    let subpageRoute = cleanedYear;
    if (subpage) {
      switch (subpage) {
        case 'anniversary':
          subpageRoute += '-anniversary';
          break;

        default:
          return Promise.reject(new Error('Invalid Year'));
      }
    }

    // Don't worry about this token. Can be public. Talked to Harry.
    const cacheKeyUrl = `https://${host}/api/v1/franchise/ibd-${subpageRoute}?token=33FDDA6B-93D3-40A7-83E9-E2AA671FEC07`;
    const cacheKey = `${cacheNamespace}:${cacheKeyUrl}`;

    if (!cacheEnabled) {
      return request.getAsync(cacheKeyUrl, options);
    }

    return cachingService.getAsync(cacheKey).then(function fromCache(cacheRes) {
      if (cacheRes) {
        return Promise.resolve(JSON.parse(cacheRes));
      }

      if (!canUseDOM) {
        log.info(`Requesting: ${cacheKeyUrl} from model.`);
      }

      return request
        .getAsync(cacheKeyUrl, options)
        .then(function fetchSuccess(resp) {
          cachingService.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
    });
    // END ==============================================
    // return Promise.reject(new Error('Invalid Year'));
  }
}
